"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentAssets = exports.Options_ShipmentAssets = void 0;
exports.Options_ShipmentAssets = ['shipment-asset'];
exports.ShipmentAssets = {
    fileTypes: ['pdf', 'tif', 'jpeg', 'jpg', 'png'],
    key: 'shipment-asset',
};
